import Image from 'next/image';
import { APP_NAME, getLocale } from '@hub/libs/constants';
import { useTranslation } from 'next-i18next';
import { openPopupWin } from '@hub/libs/ui.helper';
import { Link } from '@hub/common/Link/Link';
import { useRouter } from 'next/router';
import Locale from '@formatjs/intl-locale';
import { IGUS_REWRITE } from '@hub/libs/redirect.helper';

export const Footer = () => {
  const { t, ready } = useTranslation('layout/footer');

  const router = useRouter();

  const localeString = getLocale(router);
  const locale = new Locale(localeString);
  const footerImageLanguage = locale.language === 'de' ? 'DE' : 'EN'; // all non german sites use the EN version

  const openPrivacy = () =>
    openPopupWin(IGUS_REWRITE(t('FOOTER.LINKS.PRIVACY_URL'), localeString), 'DSE', true, false, 685, 525);
  const openImprint = () =>
    openPopupWin(IGUS_REWRITE(t('FOOTER.LINKS.IMPRINT_URL'), localeString), 'Info', true, false, 685, 450);
  const openTerms = () =>
    openPopupWin(IGUS_REWRITE(t('FOOTER.LINKS.TERMS_URL'), localeString), 'Info', true, false, 685, 450);

  return !ready ? null : (
    <div className="container igus-text-styles" data-testid="old-footer-component">
      <div className="border-t border-igus-primary mt-20">
        <ul className="flex flex-col sm:flex-row flex-wrap ml-6 sm:ml-0 font-medium text-gray-500 text-xs">
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.COMPANY')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.COMPANY_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.CAREER')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.CAREER_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.PRESS')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.PRESS_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.EXHIBITION')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.EXHIBITION_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link text={t('FOOTER.LINKS.NEWSLETTER')} primary={false} href={t('FOOTER.LINKS.NEWSLETTER_URL')} />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.CART')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.CART_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.BECOME_DISTRIBUTOR')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.BECOME_DISTRIBUTOR_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.LOCATION_MAP')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.LOCATION_MAP_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <button onClick={openPrivacy} type="button">
              {t('FOOTER.LINKS.PRIVACY')}
            </button>
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <Link
              text={t('FOOTER.LINKS.COOKIE_POLICY')}
              primary={false}
              href={IGUS_REWRITE(t('FOOTER.LINKS.COOKIE_POLICY_URL'), localeString)}
            />
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            <button onClick={openImprint} type="button">
              {t('FOOTER.LINKS.IMPRINT')}
            </button>
          </li>

          <li className="pr-10 pt-10 sm:pt-6">
            <button onClick={openTerms} type="button">
              {t('FOOTER.LINKS.TERMS')}
            </button>
          </li>
          <li className="pr-10 pt-10 sm:pt-6">
            igus<sup>®</sup> {new Date().getFullYear()}
          </li>
        </ul>
        <div className="mt-12">
          <Image
            width={1170}
            height={160}
            alt={`disclaimer_${footerImageLanguage}`}
            src={`/_${APP_NAME}/images/disclaimer_${footerImageLanguage}.png`}
            sizes="100vw"
            style={{
              width: '100%',
              height: 'auto',
            }}
          />
        </div>
      </div>
    </div>
  );
};
